import AuthError from './AuthError'

/**
 * LoginError
 */
export default class LoginError extends AuthError {}
